import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { cloudOfflineOutline, wifiOutline, checkmarkCircleOutline } from 'ionicons/icons';
import { Subject, timer } from 'rxjs';
import { takeUntil, distinctUntilChanged, tap } from 'rxjs/operators';
import { TranslocoPipe } from '@jsverse/transloco';
import { NetworkService } from '../../../core/services/network.service';

@Component({
  selector: 'app-offline-indicator',
  templateUrl: './offline-indicator.component.html',
  styleUrls: ['./offline-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon, TranslocoPipe]
})
export class OfflineIndicatorComponent implements OnInit, OnDestroy {
  private networkService = inject(NetworkService);
  private destroy$ = new Subject<void>();

  isOnline = true;
  showBackOnline = false;

  ngOnInit() {
    addIcons({ cloudOfflineOutline, wifiOutline, checkmarkCircleOutline });

    this.networkService.getIsOnline().pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(online => {
      const wasOffline = !this.isOnline;
      this.isOnline = online;

      // Briefly show "back online" banner
      if (online && wasOffline) {
        this.showBackOnline = true;
        timer(3000).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.showBackOnline = false;
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
